import {
    blockedStatusIconClass,
    blockedStatusLabel,
    blockedStatusTextClass
} from './sp-blocked-status.exports';

export class Controller {

    $onChanges() {
        this.tooltipKey = blockedStatusLabel(this.blockedStatus);
        this.iconClass = blockedStatusIconClass(this.blockedStatus);
        this.textClass = blockedStatusTextClass(this.blockedStatus);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-blocked-status/sp-blocked-status.controller.js